const permissionsApi = ({ apiClient }) => ({
  list() {
    return apiClient.get('permissions')
  },
  show(id) {
    return apiClient.get(`permissions/${id}`)
  },
  store(payload = {}) {
    return apiClient.post('permissions', payload)
  },
  update(id, payload = {}) {
    return apiClient.put(`permissions/${id}`, payload)
  },
  destroy(id) {
    return apiClient.delete(`permissions/${id}`)
  },
})
export default permissionsApi
